/**
 * @param { Promise } promise
 * @param { Object= } errorExt - Additional Information you can pass to the err object
 * @return { Promise }
 * @example const [error, data] = await awaitTo(api)
 */
export async function awaitTo<T, U = Error>(
  promise: Promise<T>,
  errorExt?: object
): Promise<[U, undefined] | [null, T]> {
  try {
    const data = await promise;
    const result: [null, T] = [null, data];
    return result;
  } catch (err: any) {
    if (errorExt) {
      const parsedError = Object.assign({}, err, errorExt) as U;
      return [parsedError, undefined];
    }
    const result_1: [U, undefined] = [err, undefined];
    return result_1;
  }
}

export default awaitTo;
